module.exports = __webpack_public_path__ + "img/171.1de781aa.jpg";